<div class="form-check form-switch mb-0">
    <input class="form-check-input" type="checkbox" role="switch" [attr.id]="id" (change)="isValueChecked($event)" (keyup)="isValueChecked($event)" [disabled]="disabled"
        [checked]="checked">
    <label class="form-check-label" [for]="id">{{labelText}}</label>
</div>